export default __webpack_public_path__ + "static/media/fakurian-design-58Z17lnVS4U-unsplash (1).b7048b08.png";